import { render, staticRenderFns } from "./merchantCourseaccount.vue?vue&type=template&id=27c58db5&scoped=true"
import script from "./merchantCourseaccount.vue?vue&type=script&lang=js"
export * from "./merchantCourseaccount.vue?vue&type=script&lang=js"
import style0 from "./merchantCourseaccount.vue?vue&type=style&index=0&id=27c58db5&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c58db5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27c58db5')) {
      api.createRecord('27c58db5', component.options)
    } else {
      api.reload('27c58db5', component.options)
    }
    module.hot.accept("./merchantCourseaccount.vue?vue&type=template&id=27c58db5&scoped=true", function () {
      api.rerender('27c58db5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/merchantAccount/detail-pane/merchantCourseaccount.vue"
export default component.exports